import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'remove-products-dialog',
    templateUrl: './remove-products-dialog.component.html',
    styleUrls: ['./remove-products-dialog.component.scss'],
})
export class RemoveProductsDialogComponent {

  @Input() rtl = false;
  @Output() close = new EventEmitter();
  @Output() accept = new EventEmitter();
  @Output() cancel = new EventEmitter();

  closeModal() {
    this.close.emit();
  }

  acceptReset() {
    this.accept.emit();
  }

  cancelReset() {
    this.cancel.emit();
  }
}
